export const MARKETING_ACCOUNT_ROUTES = {
  ONBOARDING: '/marketing-account-onboarding/redirect',
  MATCHES: '/marketing-account-matches/redirect',
};
